<template>
  <div class="plan-pagos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Plan de Pagos">
          <b-form>
            <b-form-group
              label="Nro Plan"
              label-for="numero"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="numero"
                v-model.trim="$v.numero.$model" 
                :state="numeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroFeedback">
                {{ numeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Organismo"
              label-for="impuestoOrganismo"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="impuestoOrganismo"
                :value="impuestoOrganismo"
                readonly
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Impuesto"
              label-for="proveedor"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="proveedor"
                :value="proveedor"
                readonly
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Cuenta"
              label-for="bancoCuentaNombre"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="bancoCuentaNombre"
                :value="bancoCuentaNombre"
                readonly
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Capital"
              label-for="importeCapital"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importeCapital"
                :value="importeCapital | moneda"
                readonly 
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Intereses"
              label-for="importeIntereses"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importeIntereses"
                :value="importeIntereses | moneda"
                readonly 
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Int. Resarcit."
              label-for="importeInteresesResarcitorios"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importeInteresesResarcitorios"
                :value="importeInteresesResarcitorios | moneda"
                readonly 
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Total"
              label-for="importeTotal"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importeTotal"
                :value="importeTotal | moneda"
                readonly 
                type="text">
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
        <b-card header="Detalle de Cuotas">
          <b-table 
              small 
              responsive="sm" 
              class="registro"
              :items="cuotas" 
              :fields="cuotasFields">
            <template v-slot:cell(fechaVencimiento)="data">
              <template v-if="data.item.capitalCancelado 
                  || data.item.interesesCancelado
                  || data.item.interesesResarcitoriosCancelado
                  || data.item.refinanciado">
                {{ data.item.fechaVencimiento | fecha }}
              </template>
              <template v-if="!data.item.capitalCancelado 
                  && !data.item.interesesCancelado
                  && !data.item.interesesResarcitoriosCancelado
                  && !data.item.refinanciado">
                  <input type="date"
                      v-model="data.item.fechaVencimiento"/>
              </template>
            </template>
            <template v-slot:cell(importeCapital)="data">
              <template v-if="data.item.capitalCancelado || data.item.refinanciado">
                {{ data.item.importeCapital | moneda }}
              </template>
              <template v-if="!data.item.capitalCancelado && !data.item.refinanciado">
                  <input type="number"
                      v-model="data.item.importeCapital"
                      @input="calcularTotales"/>
              </template>
            </template>
            <template v-slot:cell(importeIntereses)="data">
              <template v-if="data.item.interesesCancelado || data.item.refinanciado">
                {{ data.item.importeIntereses | moneda }}
              </template>
              <template v-if="!data.item.interesesCancelado && !data.item.refinanciado">
                  <input type="number"
                      v-model="data.item.importeIntereses"
                      @input="calcularTotales"/>
              </template>
            </template>
            <template v-slot:cell(importeInteresesResarcitorios)="data">
              <template v-if="data.item.interesesResarcitoriosCancelado || data.item.refinanciado">
                {{ data.item.importeInteresesResarcitorios | moneda }}
              </template>
              <template v-if="!data.item.interesesResarcitoriosCancelado && !data.item.refinanciado">
                  <input type="number"
                      v-model="data.item.importeInteresesResarcitorios"
                      @input="calcularTotales"/>
              </template>
            </template>
          </b-table>

          <b-table 
              small 
              responsive="sm"
              class="registro totales" 
              :items="totales" 
              :fields="totalesFields">
            <template v-slot:cell(importeCapital)="data">
              {{ data.item.importeCapital | moneda }}
            </template>
            <template v-slot:cell(importeIntereses)="data">
              {{ data.item.importeIntereses | moneda }}
            </template>
            <template v-slot:cell(importeInteresesResarcitorios)="data">
              {{ data.item.importeInteresesResarcitorios | moneda }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'planPagos/getField',
  mutationType: 'planPagos/updateField',
});

export default {
  name: 'PlanPagosABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal, 
  ],
  data: () => {
    return {
      noValidar: true,
      numeroValido: null,
      numeroInvalidoMsj: '',
      // cuotasValidas: null,
      // cuotasInvalidasMsj: '',
      // importeValido: null,
      // importeInvalidoMsj: '',
      // bancoCuentaValida: null,
      // bancoCuentaInvalidaMsj: '',

      labelCols: 2,

      cuotasFields: [
        {
          key: 'numeroCuota',
          label: 'Nro Cuota'
        },
        {
          key: 'fechaVencimiento'
        },
        {
          key: 'importeCapital',
          label: 'Capital',
          class: 'text-right'
        },
        {
          key: 'importeIntereses',
          label: 'Intereses',
          class: 'text-right'
        },
        {
          key: 'importeInteresesResarcitorios',
          label: 'Intereses Resarcit.',
          class: 'text-right'
        },
      ],

      totalesFields: [
        {
          key: 'totales',
        },
        {
          key: 'col2',
        },
        {
          key: 'importeCapital',
          label: 'Capital',
          class: 'text-right'
        },
        {
          key: 'importeIntereses',
          label: 'Intereses',
          class: 'text-right'
        },
        {
          key: 'importeInteresesResarcitorios',
          label: 'Intereses Resarcit.',
          class: 'text-right'
        },

      ],
    }
  },
  computed: {
    ...mapFields([
      'numero',
      'proveedor',
      'impuestoOrganismo',
      'bancoCuentaNombre',
      'importeCapital',
      'importeIntereses',
      'importeInteresesResarcitorios',
      'importeTotal',
      'cuotas',
      'totales'
    ]),
  },
  created() {
    let planPagosId = 0;
    if (this.$route) {
      if (this.$route.params) {
        if (this.$route.params.id) {
          planPagosId = this.$route.params.id;
        }
      }
    }

    this.showSpinner();
    this.$store.dispatch('planPagos/getPlanPagos', planPagosId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'numero' || validarTodos) {
        if (this.$v.numero.$error) {
          this.numeroValido = false;
          if (!this.$v.numero.required) {
            this.numeroInvalidoMsj = 'Debe ingresar el número de plan';
          } else if (!this.$v.numero.maxLength) {
              this.numeroInvalidoMsj = 'El número del plan de pagos puede contener hasta 50 caracteres';
          }     
        } else {
          this.numeroValido = null;
          this.numeroInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.showSpinner();
          this.$store.dispatch('planPagos/save')
            .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        } 
      }
    },
    goList() {
      this.$router.push({ name: 'PlanesPagos' });
    },
    calcularTotales() {
      this.$store.dispatch('planPagos/calcularTotales');
    },
  },
  validations: {
    numero: {
      required,
      maxLength: maxLength(50)
    },
  },    
}
</script>

<style>
  .plan-pagos .registro table thead th {
    border-top: none;
    border-bottom: none;
  }

  .plan-pagos .registro table td {
    vertical-align: middle;
  }
  .plan-pagos .registro table td[aria-colindex="1"] {
    width: 15%;
  }
  .plan-pagos .registro table td[aria-colindex="2"] {
    width: 25%;
  }
  .plan-pagos .registro table td[aria-colindex="3"],
  .plan-pagos .registro table td[aria-colindex="4"],
  .plan-pagos .registro table td[aria-colindex="5"] {
    width: 20%;
  }

  .plan-pagos .registro table td input {
    width: 90%;
    left: 5%;
    margin: 0; 
    text-align: right;
    appearance: textfield;
    -moz-appearance:textfield;
    border: none;
    border-bottom: 1px solid rgba(32, 168, 216, 0.8);
  }
  .plan-pagos .registro table td input[type=number]::-webkit-inner-spin-button, 
  .plan-pagos .registro table td input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
  }

  .plan-pagos .registro.totales table thead {
    display: none;
  }
  .plan-pagos .registro.totales table tr td {
    border-top: none;
    font-weight: bold;
  }
</style>
